<template>
  <div id="orderList" class="orders">
    <Refresh show_unbind="1" />
    <div class="orders-box">
      <div class="van-tabs">
       
        <form action="/">
          <van-search v-model="search" show-action :clearable="false"  placeholder="请输入搜索关键词"  @search="onSearch">
            <template #action>
              <div @click="onSearch" style="color: #1989fa;">搜索</div>
            </template>
          </van-search>
        </form>
        <van-tabs v-model="active" @click="onClick" title-active-color="#1F97EE" color="#1F97EE">
          <van-tab title="今日招聘" name="1"></van-tab>
          <van-tab title="预招聘" name="2"></van-tab>
        </van-tabs>
      </div>
      <div v-if="orders.length!=0">
        <ul>
          <template v-if='active==1'>
          <li class="orders-item" v-for="order in orders" :key="order.id" @click="goToDetail(order.id)">
            <div class="orders-item-left"><img class="img" :src="order.logo" /></div>
            <div class="orders-item-right">
              <div class="orders-item-title">{{ order.job_title }}</div>
              <div class="orders-item-label">
                <div v-for="label in order.label_data" :key="label">{{ label }}</div>
              </div>
              <div class="orders-item-price">
                <div>
                  <span class="price">{{ order.start_salary }}-{{ order.end_salary }}</span><span
                    class="text">元/月</span>
                </div>
                <div class="remaining">剩余名额 <span class="remaining_num">{{order.usable_number}}</span> </div>
              </div>
              <div class="orders—btn">
                <van-button type="info" size="mini" @click.stop="send(order, order.id)">发送订单</van-button>
                <van-button type="info" size="mini" class="orders—btn-item"
                  @click.stop="SignUp(order.id,order.is_limit_applets,'帮他报名')">帮他报名</van-button>
                <van-button type="info" size="mini" class="orders—btn-item"
                  @click.stop="SignUp(order.id,order.is_limit_applets,'帮其他人报名')">帮其他人报名</van-button>
              </div>
              <div class="orders—btn" style="margin-top: 10px;">
                <van-button type="info" size="mini" @click.stop="sendMessage(order, order.id)">发送会员报名通知</van-button>
                <van-button type="info" size="mini" class="orders—btn-item" @click.stop="sendPoster(order.id)">发送海报</van-button>
              </div>
            </div>
          </li>
          </template>
          <template v-if='active==2'>
          <div v-for="(item,index) in orders" :key="index">
             <div class="dateTime">{{ item.date }}</div>
              <li class="orders-item" v-for="order in item.list" :key="order.id" @click="goToDetail(order.id)">
                <div class="orders-item-left">
                  <img class="img" :src="order.logo" style="margin-bottom: 4px;" />
                  <div class="remaining">招聘时间：{{item.date}}</div>
                </div>
                <div class="orders-item-right">
                  <div class="orders-item-title">{{ order.job_title }}</div>
                  <div class="orders-item-label">
                    <div v-for="label in order.label_data" :key="label">{{ label }}</div>
                  </div>
                  <div class="orders-item-price">
                    <div>
                      <span class="price">{{ order.start_salary }}-{{ order.end_salary }}</span><span
                        class="text">元/月</span>
                    </div>
                    <div class="remaining">剩余名额 <span class="remaining_num">{{ order.usable_number }}</span> </div>
                  </div>
                  <div class="orders—btn">
                    <van-button type="info" size="mini" @click.stop="send(order, order.id)">发送订单</van-button>
                    <van-button type="info" size="mini" class="orders—btn-item"
                      @click.stop="SignUp(order.id, order.is_limit_applets, '帮他报名')">帮他报名</van-button>
                    <van-button type="info" size="mini" class="orders—btn-item"
                      @click.stop="SignUp(order.id, order.is_limit_applets, '帮其他人报名')">帮其他人报名</van-button>
                  </div>
                  <div class="orders—btn" style="margin-top: 10px;">
                    <van-button type="info" size="mini" @click.stop="sendMessage(order, order.id)">发送会员报名通知</van-button>
                    <van-button type="info" size="mini" class="orders—btn-item"
                      @click.stop="sendPoster(order.id)">发送海报</van-button>
                  </div>
                </div>
              </li>
            </div>
          </template>
        </ul>
      </div>
      <div v-else style="background-color: #fff;">
        <van-empty description="暂无更多订单~" />
      </div>
    </div>
    <!-- 帮他报名/帮其他人报名弹窗 -->
    <van-dialog :closeOnPopstate="true" v-model="dialogVisible" :title="title" :showConfirmButton="false">
      <div style="max-height: 500px;overflow: auto;padding:10px;">
        <div class="orders_list">
          <div class="orders_list_left"><span>*</span>会员姓名</div>
          <input type="text" v-model="pram.real_name" placeholder="请输入会员姓名" />
        </div>
        <div class="orders_list">
          <div class="orders_list_left"><span>*</span>手机号</div>
          <input type="number" v-model="pram.phone" placeholder="请输入手机号" />
        </div>
        <div class="orders_list">
          <div class="orders_list_left"><span>*</span>身份证号</div>
          <div class="orders_list_right">
            <input type="text" v-model="pram.id_number" placeholder="请输入身份证号" @input="blurIdNumber" :maxlength="18" />
            <van-uploader :after-read="afterRead">
              <van-icon name="scan" size="26" color="#1989fa" />
            </van-uploader>
          </div>
        </div>
        <div class="orders_list">
          <div class="orders_list_left"><span>*</span>前往方式</div>
          <van-radio-group v-model="pram.way_to_go" direction="horizontal">
            <van-radio :name="item.type" v-for="(item,index) in radioList" :key="index">{{ item.title }}</van-radio>
          </van-radio-group>
        </div>
        <div class="orders_list" v-if="!isShowmemberSourceList">
          <div class="orders_list_left"><span>*</span>会员来源</div>
          <van-radio-group v-model="pram.member_source" direction="horizontal">
            <van-radio style="margin-bottom: 5px;" :name="item.status" v-for="(item,index) in memberSourceList"
              :key="index">{{ item.title }}</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div class="orders_tips" v-if="operaLimit">{{ operaLimitMessage }}</div>
      <van-button style="width: 50%;" type="default" @click="onCancel">取消</van-button>
      <van-button style="width: 50%;" type="info" :disabled="isDisabled" @click="isShowconfirm?confirm():''">
        确定
        <template v-if="isDisabled && operaLimit && operaLimit != 'order_lock'">
          ({{countdown}}秒)
        </template>
      </van-button>
    </van-dialog>
    <!-- 滑块校验 -->
     <!-- 滑块 -->
<div class="slide_model" v-if="slidebel">
  <div class="slide_wrapper">
    <!-- 拼图图片部分 -->
    <div class="canvas_img" id="canvas_img">
      <!-- 背景图片 -->
      <canvas :style="{width: canvas_width + 'px', height: (canvas_width * 13 / 28) + 'px'}" id="firstCanvas"></canvas>
      <!-- 被抠方块 -->
      <div class="canvas_view" :style="{left: canfile_x + 'px', top: canfile_y + 'px'}"></div>
      <!-- 可移动空格 -->
      <img v-if="canfile_image" 
        class="canfile_image"
        :style="{
          top: canfile_y + 'px', // 保持与被抠方块相同的垂直位置
          left: Math.min(slide_clientX, canvas_width - 50) + 'px' // 限制最大左偏移量
        }"
        :src="canfile_image"
      />
    </div>
    <!-- 滑块 -->
    <div class="canvas_slide">
      <div class="canvas_width"
        :style="{
          width: (slide_clientX > canvas_width-50 ? canvas_width-50 : slide_clientX) + 'px',
          background: slide_status === 2 ? '#52CCBA' : slide_status === 3 ? '#F57A7A' : ''
        }">
      </div>
      <div class="canvas_kus" 
        @touchstart="slide_start" 
        @mousedown="slide_start"
        @touchmove="slide_hmove"
        @mousemove="slide_hmove"
        @touchend="slide_chend"
        @mouseup="slide_chend"
        :style="{
          left: (slide_clientX > canvas_width-50 ? canvas_width-50 : slide_clientX) + 'px',
          color: slide_status === 0 ? '#333' : '',
          background: slide_status === 1 ? '#1991FA' : slide_status === 2 ? '#52CCBA' : slide_status === 3 ? '#F57A7A' : ''
        }">
        <div v-if="slide_status < 2" style="display: flex;align-items: center; justify-content: center;">
          <van-icon v-if="slide_status === 0" name="arrow-left" size="25px" />
          <van-icon v-else name="guide-o" size="25px" />
        </div>
        <div v-if="slide_status === 2" style="display: flex;align-items: center; justify-content: center;">
          <van-icon name="success" size="25px" />
        </div>
        <div v-if="slide_status === 3" style="display: flex;align-items: center; justify-content: center;">
          <van-icon name="cross" size="24px" />
        </div>
      </div>
      <div v-if="slide_status === 0 || slide_status === 1">拖动左边滑块完成上方拼图</div>
    </div>
    <!-- 底部按钮 -->
    <div class="canvas_guil">
      <van-icon name="replay" @click="slide_tap" class="footer-icon" size="50px" />
    </div>
  </div>
</div>
<!-- 羊毛党 -->
   <van-dialog :closeOnPopstate="true" v-model="isShowAbnormal" title="异常提示" :showConfirmButton="false">
      <div style="margin-bottom: 10px; color: #999;margin-left: 20px;">{{ abnormalMsg }}</div>
      <van-button style="width: 50%;" type="default" @click="isShowAbnormal=false">取消</van-button>
      <van-button style="width: 50%;" type="info"  @click="submit">确定</van-button>
    </van-dialog>

  </div>
</template>
<script>
import {Toast,Dialog } from "vant";
import {getOrderList,uploadFile,nexDayList,ocrIdcard,getKehuDetail,getPositionKey,qyToolHelpEnroll,FrontCheckOld,hasMemberSource,GetBrokerEnrollCheck,positionInfo,GetSendPoster} from "../../api/test";
import {login} from "../../api/test";
import {checkBind, setEnterPath,checkLoadWxConfig,getUserInfo,filterHtmlTags} from "../../utils/base";


import Refresh from "@/components/home/refresh.vue";
const wx = window.wx;
export default {
  components: {
    Refresh
  },
  data() {
    return {
      orders: [],
      active: 1,
      dialogVisible:false,
      pram:{
        enterprise_position_id:'',
        real_name:'',
        phone:'',
        id_number:'',
        way_to_go:10,
        member_source:10,
        domicile:'',
        nation:''
      },
      radioList:[
        {type:20,title:"自行到场"},
        {type:10,title:"门店集合"}
      ],
      memberSourceList:[
        {status:10,title:"非网络渠道"},
        {status:20,title:"抖音"},
        {status:30,title:"58"},
        {status:40,title:"boss"},
        {status:50,title:"公众号"},
        {status:60,title:"小程序"},
        {status:70,title:"高德"},
        {status:80,title:"快手"},
      ],
      isShowmemberSourceList:true,
      title:'帮他报名',
      isShowconfirm:true,
      search:'',
      isDisabled: false,
      operaLimit: false,
      operaLimitMessage: '',
      timer: null,
      countdown: 5,

      // 滑块
      is_limit_applets:'',
      canvas_width: 0,
      slidebel: false, //滑动弹窗
      canfile_image: '', //裁剪图片
      canfile_x: '', //被抠方块的水平位置
      canfile_y: '', //被抠方块的垂直位置
      slide_clientX: 0, //移动位置
      slide_status: 1, //0 停止操作   1 触发长按   2 正确   3 错误
      route: '',
      userInfo: '',
      isShowAbnormal: false,
      abnormalMsg:'',

    }
  },

  created () {

    // 判断绑定
    if (!checkBind(this.$router)) {
      return false;
    }
    // 判断初始化
    if (!checkLoadWxConfig(this.$router)) {
      return false;
    }
    // 获取订单
    let isShowLoad=sessionStorage.getItem('isShowLoad')
    if(isShowLoad){
      this.orders=JSON.parse(sessionStorage.getItem('orders'))
      this.active=sessionStorage.getItem('active')
    }else{
      this.getOrderListFn();
    }
  },
  destroyed(){
    clearInterval(this.timer)
  },

  methods: {
    blurIdNumber(){
      if(this.pram.id_number&&this.pram.id_number.length===18){
        let reg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
        if(reg.test(this.pram.id_number) == false){
          Toast('身份证号码有误')
        }else{
              // 显示加载提示
        Toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        hasMemberSource({id_number:this.pram.id_number}).then(res=>{
        if(res.code==200){
          this.isShowmemberSourceList=res.data.has_member_source
          setTimeout(() => {
        // 隐藏加载提示
            Toast.clear();
          }, 500);
        }
      })
        }
    
      }else if(!this.pram.id_number||this.pram.id_number.length<18){
        this.isShowmemberSourceList=true
      }
    },
    getUserId() {
      let userInfo = getUserInfo();
      this.userInfo = userInfo.userInfo;
      let qy_out_user_id = userInfo.qy_out_user_id;
      return qy_out_user_id;
    },
    async getShow() {
      let res = await getKehuDetail({
        qy_out_user_id: this.getUserId(),
        type: 0,
        visit_type: 1,
      });
      if (res.code == 200) {
        this.pram.real_name=res.data.user_detail.real_name
        this.pram.id_number=res.data.user_detail.id_number
        this.pram.phone=res.data.user_detail.phone
        this.pram.domicile= res.data.user_detail.domicile
        this.blurIdNumber()
        await this.getUserSignUpStatus()
        this.dialogVisible = true
      }
    },
    async getUserSignUpStatus(){
      const res = await GetBrokerEnrollCheck({
        enterprise_position_id: this.pram.enterprise_position_id
      })
      if(res.code === 200){
        if(res.data.status == 'order_lock'){
          this.isDisabled = true
        }
        this.operaLimit = res.data.status || false
        this.operaLimitMessage = res.data.msg
      }
    },
    async afterRead(file) {
      let that=this
      const form = new FormData()
      Toast.loading({
        message: '身份证识别中...',
        forbidClick: true,
      });
      form.append('file', file.file)
      // 此时可以自行将文件上传至服务器
      let res = await uploadFile(form)
      if (res.code == 200) {
        ocrIdcard({img_path: res.data.file_full_path}).then(request=>{
          if(request.code==200){
            if(request.data.errcode==0){
              that.pram.id_number= request.data.id
              that.pram.real_name= that.pram.real_name?that.pram.real_name:request.data.name
              that.pram.nation= request.data.nationality+'族'
              that.pram.domicile= request.data.addr
              that.blurIdNumber()
            }else{
              Dialog.alert({
                title: '未能识别身份证',
                message: '请重新拍摄或上传',
                confirmButtonColor:'#1989fa'
              }).then(() => {
                // on close
              });
            }
          }
          
        })
      }
    },

    async getOrderListFn() {
      await getOrderList({type:0,search:this.search}).then((res) => {
        if (res.code == 200) {
          this.orders = res.data.data;
        }
      })
    },
    async nexDayListFn() {
      await nexDayList({search:this.search,plan_type:2}).then((res) => {
        if (res.code == 200) {
          this.orders = res.data.positionList.data;
        }
      })
    },
    onSearch(){
      if(this.active==1){
        this.getOrderListFn()
      }else{
        this.nexDayListFn()
      }
    },
    onClick(event) {
      this.active=event
      if(event==1){
        this.getOrderListFn()
      }else{
        this.nexDayListFn()
      }
    },
    async SignUp(id,is_limit_applets,type){
      this.isShowmemberSourceList=true
      if(type=='帮他报名'){
        this.getShow()
        this.title='帮他报名'
      }else  if(type=='帮其他人报名'){
        this.title='帮其他人报名'
        this.pram=this.$options.data().pram
        this.pram.enterprise_position_id = await id
        await this.getUserSignUpStatus()
        this.dialogVisible= true
      }
      this.is_limit_applets=is_limit_applets
      this.pram.enterprise_position_id = await id
    },
    onCancel() {
      this.dialogVisible = false
      this.isDisabled = false
      this.operaLimit = false
      this.operaLimitMessage = ''
      clearInterval(this.timer)
      this.timer = null
      this.countdown = 5
    },
    getFrontCheckOld(){
      FrontCheckOld(this.pram).then(res=>{
        if(res.code==200){
          // 显示提示
          if(res.data.status == 0){
            Dialog.alert({
              title: '温馨提示',
              message: '【已报名成功】' + res.data.msg,
            }).then(() => {
              // on close
            });
          }
        }
      })
    },
    signUpFn(){
      // 显示加载提示
      Toast.loading({
        message: '报名中...',
        forbidClick: true,
      });
      this.isShowconfirm=false
        qyToolHelpEnroll(this.pram).then(res=>{
          if(res.code==200){
            if(res.data.code==202){   
              this.abnormalMsg = res.data.msg
              this.isShowAbnormal = true
              this.isShowconfirm=true
              return
            }
            this.getFrontCheckOld()
            this.isShowconfirm=true
            let title=res.data == '' ? '报名成功' : res.data
            Toast(title)
            setTimeout(()=>{
              this.onCancel()
              Toast.clear();
            },500)
          }else{
            this.isShowconfirm=true
          }
          
          // 禁用按钮并开始倒计时
          if (this.operaLimit) {
            this.startCountdown()
          }
        })
    },
    async  submit(){
      let pramsData={
        ...this.pram,
        is_jump_econnoisseur:1
      }
       Toast.loading({
        message: '报名中...',
        forbidClick: true,
      });
      this.isShowconfirm=false
          qyToolHelpEnroll(pramsData).then(res=>{
          if(res.code==200){
            this.getFrontCheckOld()
            this.isShowAbnormal=false
            this.isShowconfirm=true
            let title=res.data == '' ? '报名成功' : res.data
            Toast(title)
            setTimeout(()=>{
              this.onCancel()
              Toast.clear();
            },500)
          }else{
            this.isShowconfirm=true
          }
          
          // 禁用按钮并开始倒计时
          if (this.operaLimit) {
            this.startCountdown()
          }
        })
    },
    confirm() {
      console.log(this.is_limit_applets,'..is_limit_applets')
      if (this.isDisabled) return
      this.isShowconfirm=true
      let title=this.checkout()
      if(!title){
        if(this.is_limit_applets==1){
          this.visidlisd()
        }else{
          this.signUpFn()
        }
       
      //       // 显示加载提示
      // Toast.loading({
      //   message: '报名中...',
      //   forbidClick: true,
      // });
      // this.isShowconfirm=false
      //   qyToolHelpEnroll(this.pram).then(res=>{
      //     if(res.code==200){
      //       this.isShowconfirm=true
      //       Toast('报名成功')
      //       setTimeout(()=>{
      //         this.onCancel()
      //         Toast.clear();
      //       },500)
      //     }else{
      //       this.isShowconfirm=true
      //     }
          
      //     // 禁用按钮并开始倒计时
      //     if (this.operaLimit) {
      //       this.startCountdown()
      //     }
      //   })
      }else{
        // 禁用按钮并开始倒计时
        if (this.operaLimit) {
          this.startCountdown()
        }
        Toast(title);
      }
    },
visidlisd() {
  this.slidebel = true;
  if (this.canvas_width != 0) {
    this.slide_tap();
    return;
  }
  this.$nextTick(() => {
    const canvas_img = document.getElementById('canvas_img');
    if(canvas_img) {
      this.canvas_width = canvas_img.getBoundingClientRect().width;
      this.slide_tap();
    }
  });
},

slide_tap() {
  this.canfile_x = Math.round(Math.random() * (this.canvas_width - 120) + 60);
  this.canfile_y = Math.round(Math.random() * (this.canvas_width * 13 / 28 - 60));
  this.canfile_image = '';

  setTimeout(() => {
    const canvas = document.getElementById('firstCanvas');
    if(!canvas) return;
    
    const context = canvas.getContext('2d');
    canvas.width = this.canvas_width;
    canvas.height = this.canvas_width * 13 / 28;
    
    const img = new Image();
    // 使用require动态引入图片资源
    img.src = require('@/assets/about.png');
    console.log(img.src,'..img.src')
    img.onload = () => {
      context.drawImage(img, 0, 0, canvas.width, canvas.height);
      
      // 获取裁剪区域的图片数据
      const imageData = context.getImageData(this.canfile_x, this.canfile_y, 50, 50);
      const tempCanvas = document.createElement('canvas');
      tempCanvas.width = 50;
      tempCanvas.height = 50;
      const tempContext = tempCanvas.getContext('2d');
      tempContext.putImageData(imageData, 0, 0);
      
      this.canfile_image = tempCanvas.toDataURL();
    };
  }, 50);
},

slide_start(e) {
  console.log(1111)
  this.slide_status = 1;
},

slide_hmove(e) {
  // 判断是移动端还是PC端
  if (!this.slide_status) return;
  
  let clientX;
  if (e.touches) {
    // 移动端
    clientX = e.touches[0].clientX;
  } else {
    // PC端
    e.preventDefault(); // 阻止默认事件
    if (!e.buttons) return; // 未按下鼠标则返回
    clientX = e.clientX;
  }

  // 获取滑块容器的位置信息
  const slideContainer = document.querySelector('.canvas_slide');
  const containerRect = slideContainer.getBoundingClientRect();
  
  // 计算相对于容器的x坐标
  const relativeX = clientX - containerRect.left;
  
  // 计算滑块位置,限制在有效范围内
  const maxX = this.canvas_width - 60;
  this.slide_clientX = Math.min(Math.max(0, relativeX - 24), maxX); // 24是滑块宽度的一半
},

async slide_chend(e) {
  const maxX = this.canvas_width - 60;
  let cliextX;

  if (this.slide_clientX < 1) {
    this.slide_status = 1;
    return false;
  }

  cliextX = this.slide_clientX > maxX ? maxX : this.slide_clientX;

  if (((this.canfile_x + 5) > cliextX) && ((this.canfile_x - 5) < cliextX)) {
    this.slide_status = 2;
    this.slide_clientX = this.canfile_x;
    
    await this.signUpFn();
    
    // 重置状态
    this.canvas_width = 0;
    this.slidebel = false;
    this.canfile_image = '';
    this.canfile_x = '';
    this.canfile_y = '';
    this.slide_clientX = 0;
    this.slide_status = 1;
  } else {
    this.slide_status = 3;
  }

  setTimeout(() => {
    this.slide_status = 1;
    this.slide_clientX = 0;
  }, 500);
},

    checkout(){
      let reg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      let rePhone = /^1[3456789]\d{9}$/;
      if(!this.pram.real_name){
        return '请输入会员姓名'
      } else if(!this.pram.phone){
        return '请输入手机号'
      }else if (rePhone.test(this.pram.phone) == false) {
        return '手机号码错误'
      } else if(!this.pram.id_number){
        return '请输入身份证号'
      } else if (reg.test(this.pram.id_number) == false) {
        return '身份证号码有误'
      }else if(!this.pram.way_to_go){
        return '请选择前往方式'
      }else if(!this.isShowmemberSourceList&&!this.pram.member_source){
        return '请选择会员来源'
      }
    },
    goToDetail(id){
      this.$router.push({
        path: `/order/detail/${id}`
      });
      sessionStorage.setItem('isShowLoad',true)
      sessionStorage.setItem('orders',JSON.stringify(this.orders))
      sessionStorage.setItem('active',this.active)
    },
    async sendMessage(order, orderId){
      let res = await positionInfo({
        id: orderId,
        qy_out_user_id: this.getUserId(),
      });
      if (res.code == 200) {
        let data = res.data;
        let MembershipRegistrationNoticeToChat = `尊敬的会员您好🌹\n报名企业：${data.abbreviation}\n工价：${data.salary ? filterHtmlTags(data.salary) : ''}\n发车时间：\n经纪人：${data.users.nickname?data.users.nickname:data.users.real_name}${data.users.phone}\n温馨提示❤️：请不要喝酒熬夜，出门带好随身物品，特别是身份证，到达门店集合点请听从工作人员的安排，请勿随意走动，避免错过发车时间，祝您入职成功😊`
      console.log(MembershipRegistrationNoticeToChat,'..MembershipRegistrationNoticeToChat')
        wx.invoke('sendChatMessage', {
          msgtype: "text", //消息类型，必填
          enterChat: true, //为true时表示发送完成之后顺便进入会话，仅移动端3.1.10及以上版本支持该字段
          text:{
            content: MembershipRegistrationNoticeToChat || '',
          },
        }, function (res) {
          if (res.err_msg == 'sendChatMessage:ok') {
            //发送成功
          }
        })
      }
      
    },
    send(order, orderId) {
      getPositionKey({ position_id: orderId }).then(res => {
        if (res.code == 200) {
          let details = {};
          details.scene = res.data
          console.log(`pages/home/pages/details/details.html?details=${JSON.stringify(details)}&share_type=qy_chat_tool`)
          wx.invoke('sendChatMessage', {
            msgtype: "miniprogram", //消息类型，必填
            enterChat: true, //为true时表示发送完成之后顺便进入会话，仅移动端3.1.10及以上版本支持该字段
            miniprogram:
            {
              appid: "wx3bb67ab45cae2155",//小程序的appid，企业已关联的任一个小程序
              title: order.job_title, //小程序消息的title
              imgUrl: order.logo,//小程序消息的封面图。必须带http或者https协议头，否则报错 $apiName$:fail invalid imgUrl
              page: `pages/home/pages/details/details.html?details=${JSON.stringify(details)}&share_type=qy_chat_tool`, //小程序消息打开后的路径，注意要以.html作为后缀，否则在微信端打开会提示找不到页面
            },
          }, function (res) {
            if (res.err_msg == 'sendChatMessage:ok') {
              //发送成功
            }
          })
        }
      })
    },
    sendPoster(orderId) {
      console.log(wx.invoke,orderId,'wx.invoke')
      GetSendPoster({ position_id: orderId }).then(response => {
        if (response.code == 200) {
          if(!response.data){
            Toast('订单暂无海报生成')
            return
          }
          wx.invoke('sendChatMessage', {
            msgtype: 'image', // 消息类型为图片
            image: {
              mediaid: response.data, // 图片的素材id
            }
          }, function(res) {
            console.log(response.data,'..response.data')
            if (res.err_msg === 'sendChatMessage:ok') {
              console.log('发送成功');
            } else {
              console.error('发送失败:', res);
              // 可以根据不同的错误码进行特定处理
            }
          });
        }
      })
    },
    startCountdown() {
      this.isDisabled = true 
      const timer = setInterval(() => {
        if (this.countdown <= 1) {
          clearInterval(timer)
          this.isDisabled = false
          this.countdown = 5
          return
        }
        this.countdown = this.countdown - 1
      }, 1000)
      this.timer = timer
    },
  }
}
</script>

<style scoped>
.img{
  width: 120px;
  height: 120px;
  position: relative;
}
.orders img{
  border-radius: 3px;
  /* width: 120px;
  height: 120px; */
  overflow: hidden;
  /* position: relative; */
}
.orders-item {
  padding: 20px 10px;
  clear: both;
  display:flex;
  align-items: center;
  background: #fff;
  margin-bottom: 5px;
  
}
.orders-item-left {
  /* float: left; */
}
.orders-item-right {
  /* float: left; */
  margin-left: 10px;
  flex: 1;
}
.orders-item-title {
  font-size: 1.2em;
  /* margin-top: 10px; */
  overflow: hidden;
  text-overflow: ellipsis;
}
.orders-item-label {
  margin-top: 10px;
  display: flex;
  align-items: center;
}
.orders-item-label div{
  margin-right: 5px;
  font-size: 1em;
  color: #1F97EE;
  background-color: #E9F5FF;
  padding: 5px;
  box-sizing: border-box;
  border-radius: 5px;
  line-height: 100%;
}
.orders-item-price {
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.orders-item-price .price{
  color: #FF4E3A;
  font-weight: bold;
  font-size: 1.2em;
}
.orders-item-price .text {
  color: #A2A2A2;
}
.orders-item .send {
  height: auto;
  padding: 3px 15px;
  margin-left: 10px;
}

.remaining{
    font-size: 12px;
    color: #999999;
    text-align: right;
}
.remaining_num{
    color: #ff603e;
    font-weight: 400;
}
/* .orders—btn{
  display: flex;
  te
} */
.orders—btn-item{
  margin-left: 10px !important;
}
.van-tabs{
  position: sticky;
  top: 46px;
  z-index: 999;
}
.orders-box{
  background: #f5f5f5;
}
.orders_list_left {
  margin-right: 5px;
  flex-shrink: 0;
  width: 28%;
}

.orders_list_left span {
  color: #E25050;
  margin-left: 2px;
}

.orders_list {
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  border-bottom: 1px solid #f2f2f2;
  padding: 20px 0;
  box-sizing: border-box;
}
.orders_list:last-child{
  border-bottom:none;
}

.orders_list input {
  /* text-align: right; */
  /* flex: 1; */
  font-size: 15px;
  font-weight: 300;
  color: #ABABAB;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border: none;
}
.orders_list_right{
  display: flex;
  text-align: center;
}
.orders_list_right input{
  width: 80%;
}
.index_search {
  display: flex;
  align-items: center;
  width: 100%;
  background-color: #F5F5F5;
  height: 70rpx;
  z-index: 96;
  border-radius: 40rpx;
  padding: 5rpx 5rpx 5rpx 30rpx;
  box-sizing: border-box;
}

.orders_tips{
  padding: 0 10px 10px;
  color: #F56C6C;
  font-size: 14px;
}

.slide_model {
    width: 100%;
    height: 100vh;
    z-index: 999999;
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .slide_wrapper {
    float: left;
    z-index: 1;
    position: relative;
    width: 90%;
    background-color: #fff;
  }
  
  .canvas_img {
    width: 90%;
    min-height: 150px;
    position: relative;
    margin: 25rpx auto 0;
  }
  #firstCanvas {
    z-index: 1 !important;
    width: 100%;
    height: 100%;
  }
  
  /* 被抠的空格 */
  .canvas_view {
    width: 50px;
    height: 50px;
    position: absolute;
    background: rgba(0, 0, 0, 0.6);
    z-index: 2;
    box-shadow: 0 0 5px 2px rgba(255, 255, 255, 0.5);
  }
  /* 移动的空格 */
  .canfile_image {
    width: 50px;
    height: 50px;
    position: absolute;
    left: 0;
    z-index: 3;
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.8);
    box-sizing: border-box;
  }
  .canfile_image::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    box-shadow: 0 0 8px 5px rgba(255, 255, 255, 0.8) inset;
  }
  .canvas_slide {
    width: 90%;
    height: 45px;
    background: #eee;
    text-align: center;
    line-height: 80rpx;
    margin: 0 auto;
    position: relative;
    font-size: 26rpx;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  /* 滑条上滑块经过的部分 */
  .canvas_width {
    position: absolute;
    left: 0;
    top: 0;
    height: 45px;
    background-color: #1991FA;
    width: 0;
    border-top: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
  }
  /* 滑块 */
  .canvas_kus {
    width: 48px;
    height: 45px;
    background-color: #fff;
    font-size: 36rpx;
    font-weight: 700;
    position: absolute;
    left: 0;
    top: 0;
    border: 1px solid #ddd;
    color: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  }
  .canvas_kus>view {
    width: 100%;
    height: 100%;
    background-position: center;
    background-size: 50% 40%;
    background-repeat: no-repeat;
  }
  
  /* 底部按钮位置 */
  .canvas_guil {
    width: 100%;
    border-top: 1px solid #f4f4f4;
    height: 100rpx;
    display: flex;
    align-items: center;
    float: left;
    font-size: 30rpx;
    color: #666;
  }
  
  .canvas_guil>image {
    margin-left: 30rpx;
  }
  .dateTime{
    text-align: center;
    color: #666;
    margin: 6px 0;
  }
</style>
